<template>
  <div class="seeds">
    <ul class="seeds__list">
        <li
          v-for="crop in store.crops"
          :key="crop.SeedCropName"
          class="seeds__seed"
          :class="{ active:crop.SeedCropName == store.activeSeed }"
          @click="store.setActiveSeed(crop.SeedCropName, crop.SeedCropTgw, crop.SeedCropGerminationRate, crop.SeedCropFieldLosses)">
          <div class="seeds__image">
            <img
              :src=crop.SeedCropImage
              :alt=crop.SeedCropName
            >
          </div>
          <div class="seeds__name">{{ crop.SeedCropName }}</div>
        </li>
    </ul>
  </div>
</template>

<script setup>

import { useSeedRateCalculatorStore } from '../store/store.js';

const store = useSeedRateCalculatorStore();

</script>